module.exports = __webpack_public_path__ + "static/img/game-rating-administration-committee-oidd.70a7a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/game-rating-administration-committee-oidd.jpg
// module id = SDPr
// module chunks = 0